/**
 * Every entity the billing audit log records, with the label both audit log pages show for it.
 * Console entities carry the `console-` prefix; the Billing Manager marks them as such. A billing
 * server test fails when an audited route records an entity missing here.
 */
export const BILLING_AUDIT_ENTITY_LABELS = {
    'ai-conversation': 'AI conversation',
    'ai-eula': 'AI EULA',
    'ai-price': 'AI price',
    appliance: 'Appliance',
    'appliance-license-allocation': 'Appliance license allocation',
    'appliance-license-bundle': 'Appliance license bundle',
    'appliance-license-product': 'Appliance license product',
    'appliance-license-purchase': 'Appliance license purchase',
    'appliance-license-transfer': 'Appliance license transfer',
    'appliance-ssh-certificate': 'Appliance SSH certificate',
    'appliance-transfer': 'Appliance transfer',
    'console-appliance-license-allocation': 'Appliance license allocation',
    'console-installation': 'Installation',
    'console-invitations': 'Invitation',
    'console-passkey': 'Passkey',
    'console-password': 'Password',
    'console-password-reset': 'Password reset',
    'console-user': 'User',
    customer: 'Customer',
    'customer-rtu': 'Customer RTU',
    'customer-rtu-transfer': 'RTU transfer',
    'external-user': 'External user',
    'external-user-invitation': 'External user invitation',
    globalsettings: 'Global settings',
    installation: 'Installation',
    license: 'License',
    passkey: 'Passkey',
    'password-reset': 'Password reset',
    'ssh-key': 'SSH key',
    user: 'User',
    // Entries recorded before passkeys, SSH keys, passwords and NetSuite imports had entities of
    // their own; they remain until audit retention removes them.
    'console-current-user': 'Current user',
    'current-user': 'Current user',
    netsuite: 'NetSuite import',
} as const satisfies Record<string, string>

export type BillingAuditEntity = keyof typeof BILLING_AUDIT_ENTITY_LABELS

/** Entities only older entries carry. A route recording one must name its real entity instead. */
export const LEGACY_BILLING_AUDIT_ENTITIES: ReadonlySet<BillingAuditEntity> = new Set([
    'console-current-user',
    'current-user',
    'netsuite',
])

export const isBillingAuditEntity = (entity: string): entity is BillingAuditEntity =>
    Object.hasOwn(BILLING_AUDIT_ENTITY_LABELS, entity)
